import { Component, Input, ElementRef, ViewChild, OnInit, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import * as D3 from "d3";

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent implements OnInit, AfterViewInit {

  // @ViewChild("containerPieChart") element: ElementRef;
  @Input() containerId: any;
  @Input() data: any;

  public contId: any;

  private host;
  private svg;
  private width: number;
  private height: number;
  private radius: number;
  private htmlElement: HTMLElement;

  constructor() { }

  ngOnInit() {
    this.contId = `pie-container-${this.containerId}`;
    // this.buildPie();
  }

  ngAfterViewInit() {
    // this.htmlElement = this.element.nativeElement;
    // this.host = D3.select(this.htmlElement);
    // this.setup();
    // this.buildSVG();
    // this.buildPie();
  }

  /*public async ngOnChanges(changes: SimpleChanges) {
    if (changes.data) {
      console.log("changes!!!")
      this.host = D3.select(this.htmlElement);
      this.buildPie();
    }
  }*/


  /*private buildSVG(): void {
    this.host.html("");
    this.svg = this.host.append("svg")
      .attr("viewBox", `0 0 ${this.width} ${this.height}`)
      .append("g")
      .attr("transform", `translate(${this.width / 2},${this.height / 2})`);
  }*/

  private buildPie(): void {

    console.log("build PIE ", this.data);

    let w = 600;
    let h = 400;
    let r = Math.min(w, h)/2;
    let labelr = r + 30; // radius for label anchor
    let color = D3.scaleOrdinal().range(["#244238", "#89BE4A", "#7b6888", "#6b486b", "#a05d56"]);
    let donut = D3.pie();
    let arc = D3.arc().innerRadius(r*.6).outerRadius(r);

    this.host = D3.select(`#${this.contId}`);

    console.log("CONT ID ==> ", this.contId);
    console.log("element? ", document.getElementById(this.contId));

    console.log("host ==> ", this.host);

    this.svg = this.host.append("svg")
      .attr("viewBox", `0 0 ${w} ${h}`)
      .append("g")
      .attr("transform", `translate((${r}+60), ${r})`);

    /*let pie = D3.pie()
      .value((d: any) => { return d.numero });

    let arcSelection = this.svg.selectAll(".arc")
      .data(pie(this.data))
      .enter()
      .append("g")
      .attr("class", "arc");


    let pieColor = D3.scaleOrdinal()

    let arc = D3.arc()
      .innerRadius(innerRadius)
      .outerRadius(outerRadius);*/

    /*let vis = D3.select()
      .append("svg")
      .data(this.data)
      .attr("width", w + 10)
      .attr("height", h);*/


    let arcs = this.svg.selectAll(".arc")
      // .data(donut.value(function (d) { console.log("donut => ", d); return d.numero; }))
      .data(donut(this.data))
      .enter()
      .append("g")
      .attr("class", "arc")
      // .attr("transform", `translate((${r}+60), ${r})`);

      console.log("arcs =Z ", arcs)

    arcs.append("path")
      .attr("fill", (d: any, i: string) => { return color(i) })
      .attr("d", arc);

    arcs.append("text")
      .attr("text-anchor", "middle")
      .attr('x', function (d: any) {
        var a = d.startAngle + (d.endAngle - d.startAngle)/2 - Math.PI/2;
        d.cx = Math.cos(a) * (r - 45);
        return d.x = Math.cos(a) * (r+30);
      })
      .attr("y", function(d: any) {
        var a = d.startAngle + (d.endAngle - d.startAngle)/2 - Math.PI/2;
        d.cy = Math.sin(a) * (r - 45);
        return d.y = Math.sin(a) * (r + 30);
      })
      .text((datum, index) => this.data[index].sexo)
      .each(function(d: any) {
        var bbox = this.getBBox();
        d.sx = d.x - bbox.width/2 - 2;
        d.ox = d.x + bbox.width/2 + 2;
        d.sy = d.oy = d.y + 5;
      });

      arcs.append("path")
        .attr("class", "pointer")
        .style("fill", "none")
        .style("stroke", "black")
        .attr("d", function(d: any) {
         console.log("d? ==> ", d);
            // if(d.cx > d.ox) {
            return d.cx > d.ox ? `M${d.sx},${d.sy}L${d.ox},${d.oy} ${d.cx},${d.cy}` : `M${d.ox},${d.oy}L${d.sx},${d.sy} ${d.cx},${d.cy}`;
            // }
        });

      // .attr("transform", (datum: any) => {
        // datum.innerRadius = 0;
        // datum.outerRadius = outerRadius;
        // return "translate(" + arc.centroid(datum) + ")";
      // })
  }
}
